import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getCompanyDataRequest: null,
  getCompanyDataSuccess: ['response'],
  getCompanyDataFailure: null,
});

export const CompanyTypes = Types;
export default Creators;
